import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
import { useDispatch, useSelector } from 'react-redux'
// components
import { Link } from 'components/UI'
import { AddIcon, ButtonLink, RiskTemplateLabel, SectionHeader } from 'components/PageComponents/Risks/Register/views'
// themes
import { colors } from 'themes/index'
// graphql
import { RISK_TEMPLATE_CREATE_MUTATION } from 'graphql/risk/mutations'
// static
import ArchiveIconOrigin from 'src/icons/archive.svg'
// types
import { IRiskTemplateCreateResponse } from 'types/graphql'
// store
import { addRiskTemplate, riskTemplatesSelector } from 'store/reducers/riskTemplates'
// utils
import { size } from 'polished'
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

const ArchiveIcon = styled(ArchiveIconOrigin)`
  && {
    ${size('14px')};

    margin-left: auto;
    min-width: 14px;

    path {
      fill: ${colors.darkBlue400};
    }
  }
`

type RiskTemplateCreateResponse = { riskTemplateCreate: IRiskTemplateCreateResponse }

const RiskTemplatesList: React.FC = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  const [createTemplate] = useMutation<RiskTemplateCreateResponse>(RISK_TEMPLATE_CREATE_MUTATION)

  const riskTemplates = useSelector(riskTemplatesSelector)

  const riskTemplateCreate = async () => {
    try {
      const response = await createTemplate({
        variables: { input: { name: 'Form Template' } }
      })

      const { id } = response.data.riskTemplateCreate.data

      dispatch(addRiskTemplate({ id, name: 'Form Template', archived: false, fields: [] }))

      await router.push(`/forms/templates/edit/${id}`)
    } catch (e) {
      console.log('[RiskRegisterAPI.riskTemplateCreate]:', parseGraphQLErrorMessages(e))
    }
  }

  return (
    <>
      <SectionHeader>
        <h2>Templates</h2>
        <ButtonLink onClick={riskTemplateCreate}>
          <AddIcon />
          Add template
        </ButtonLink>
      </SectionHeader>

      {riskTemplates.map((riskTemplate) => (
        <RiskTemplateLabel data-testid='risk-template-list-item' key={riskTemplate.id}>
          <Link href={`/forms/templates/edit/${riskTemplate.id}`}>{riskTemplate.name}</Link>
          {riskTemplate.archived && <ArchiveIcon />}
        </RiskTemplateLabel>
      ))}
    </>
  )
}

export default RiskTemplatesList
